import React, { useState } from "react";
import { Box } from "@mui/material";
import GroupsList from "./GroupsList";
import GroupsHeader from "./GroupsHeader";
import { useAppSelector } from "../../../Redux/hooks";
import { permissions } from "../../../utils/roles";
import { dataTablePageShell } from "../../../utils/dataTableShell";

const ParticipantGroups = () => {
  const [toggleLoader, setToggleLoader] = useState<boolean>(false);

  const studyPermissions = useAppSelector(
    (state) => state.study.studyPermissions
  );
  const dataEditable = useAppSelector((state) => state.study.dataEditable);
  // A locked participant (deactivated/redacted/deleted) is read-only — group
  // management must be disabled the same way other edit surfaces are.
  const isLocked = useAppSelector((state) => state.participantTab.isLocked);
  const canCreate =
    studyPermissions.includes(permissions.manageCohort) &&
    dataEditable &&
    !isLocked;
  function refreshPage() {
    setToggleLoader((prev: boolean) => !prev);
  }
  return (
    <>
      <GroupsHeader canCreate={canCreate} refreshPage={refreshPage} />

      <Box sx={{ ...dataTablePageShell("calc(100% - 73px)"), p: 2 }}>
        <GroupsList refreshPage={refreshPage} toggleLoader={toggleLoader} />
      </Box>
    </>
  );
};

export default ParticipantGroups;
